import { ProgramToUpdate } from '@/staff/domain/program/ProgramToUpdate';
import { BackendTranslation, toBackendTranslations } from '@/common/secondary/BackendTranslation';

export interface BackendProgramToUpdate {
  slug?: string;
  imageUrl?: string;
  nameTranslations?: BackendTranslation[];
  descriptionTranslations?: BackendTranslation[];
}

export const toBackendProgramToUpdate = (programToUpdate: ProgramToUpdate): BackendProgramToUpdate => ({
  slug: programToUpdate.slug.orElseUndefined(),
  imageUrl: programToUpdate.imageUrl.orElseUndefined(),
  nameTranslations: toBackendTranslations(programToUpdate.nameTranslations),
  descriptionTranslations: toBackendTranslations(programToUpdate.descriptionTranslations),
});
